// This file is a barrel file - it acts as a single entry point so that consumers only need one import instead of many
import { paginate } from './paginate';
import { getFilterOptions } from './getFilterOptions';
import { updateTrackingNumber } from './updateTrackingNumber';
import { updateComment } from './updateComment';
import { updateOutForDelivery } from './updateOutForDelivery';
import { updatePrescriptionDetail } from './updatePrescriptionDetail';

export default {
  paginate,
  getFilterOptions,
  updateTrackingNumber,
  updateComment,
  updateOutForDelivery,
  updatePrescriptionDetail,
};
